import React from "react";
import SearchableAutocomplete from "./SearchableAutocomplete";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const FormField = ({
  field,
  value,
  onChange,
  onBlur, // accept onBlur prop
  error,
  name,
  typeOverride,
  checked,
  creditors,
}) => {
  const label = typeof field === "string" ? field : field.label;
  const type =
    typeOverride || (typeof field === "string" ? "text" : field.type || "text");

  const isAmount = type === "amount" || label === "Amount";

  if (type === "radio") {
    return (
      <label className="option">
        <input
          type="radio"
          name={name}
          value={label}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
        />
        <span>{label}</span>
      </label>
    );
  }

  if (type === "dropdown" && field.options) {
    return (
      <>
        <select
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          className={`text-grid-input dropdown ${error ? "input-error" : ""}`}
          title={error || ""} // show error on hover tooltip
        >
          <option value="" style={{ fontSize: "10px" }}>
            {"State the lawsuit was filed in".toUpperCase()}
          </option>
          {[...field.options]
            .sort((a, b) => a.localeCompare(b))
            .map((opt, i) => (
              <option key={i} value={opt}>
                {opt}
              </option>
            ))}
        </select>
      </>
    );
  }

  if (type === "searchable-dropdown" && creditors) {
    return (
      <SearchableAutocomplete
        options={creditors}
        value={value}
        onChange={onChange}
        placeholder={label}
        onBlur={onBlur}
      />
    );
  }

  if (type === "textarea") {
    return (
      <>
        <textarea
          placeholder={label}
          rows={5}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          className={`text-grid-input textarea ${error ? "input-error" : ""}`}
          title={error || ""}
        />
      </>
    );
  }
  if (type === "phone") {
    return (
      <div className="input-wrapper" style={{ position: "relative" }}>
        <PhoneInput
          country="US"
          placeholder="Phone"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={`phone-input ${error ? "error" : ""}`}
        />
        {error && <div className="tooltip">{error}</div>}
      </div>
    );
  }

  return (
    <>
      <div
        className="input-wrapper"
        style={{
          position: "relative",
          display: isAmount ? "inline-block" : undefined,
          width: isAmount ? "auto" : undefined,
        }}
      >
        {isAmount && <span className="currency-symbol">$</span>}
        <input
          type={type === "amount" ? "number" : type}
          placeholder={field.placeholder || label}
          value={value || ""}
          onChange={(e) => {
            let val = e.target.value;
            if (type === "number" || type === "amount") {
              val = val.replace(/[^0-9.]/g, "");
            }
            onChange(val);
          }}
          onBlur={onBlur}
          className={`text-grid-input ${error ? "input-error" : ""}`}
          inputMode={
            type === "number" || type === "amount" ? "decimal" : undefined
          }
          pattern={
            type === "number" || type === "amount"
              ? "\\d*(\\.\\d{0,2})?"
              : undefined
          }
          style={isAmount ? { paddingLeft: "24px" } : undefined}
          title={error || ""}
        />
      </div>
    </>
  );
};

export default FormField;
